import React from 'react';
import PropTypes from 'prop-types';
import queryString from 'querystring';
import includes from 'lodash/includes';
import {withRouter} from 'react-router-dom';

import {logCheckpointOnPageChange} from 'js-utils/janus';
import {withEventSaveNotification} from '@eb/destination-utils';
import {setPageLabel, setCustomData} from '@eb/performance-monitor';

import Layout from 'eventbrite_design_system/layout/Layout';

import FilterPanel from './FilterPanel';
import ConnectedResultsPanel from '../containers/ConnectedResultsPanel';
import ConnectedMapPanel from '../containers/ConnectedMapPanel';
import ConnectedSearchHeader from '../containers/ConnectedSearchHeader';
import ConnectedSearchFooterLegacy from '../containers/ConnectedSearchFooterLegacy';
import ConnectedSearchFooter from '../containers/ConnectedSearchFooter';
import ConnectedSearchMainContent from '../containers/ConnectedSearchMainContent';
import {
    DESTINATION_SEARCH_EVENT_CLICKED_CHECKPOINT,
    DESTINATION_MANUAL_SEARCH_EVENT_CLICKED_CHECKPOINT,
    NON_MANUAL_SOURCES,
    LUX_LABEL_SEARCH,
} from '../constants';

import './SearchBaseScreen.scss';

class SearchBaseScreen extends React.PureComponent {
    static propTypes = {
        domain: PropTypes.string.isRequired,
        onSaveEvent: PropTypes.func.isRequired,
        onTrackPageViewAction: PropTypes.func.isRequired,
        updateLocation: PropTypes.func.isRequired,
        updateSearchInformationFromUrl: PropTypes.func.isRequired,
        setSearchInformationFromUrl: PropTypes.func.isRequired,
        isAuthenticated: PropTypes.bool,
        trackEventClickInternal: PropTypes.func,
        triggerPageView: PropTypes.func,
        currentPlace: PropTypes.string,
        currentPlaceParent: PropTypes.string,
        placeType: PropTypes.string,
        isGoogleLocationAutocompleteEnabled: PropTypes.bool,
        // eslint-disable-next-line
        history: PropTypes.object,
    }

    constructor(props) {
        super(props);

        this.state = {
            shouldLoadGoogleMap: !this.props.isGoogleLocationAutocompleteEnabled,
        };
    }

    componentDidMount() {
        const {
            onTrackPageViewAction,
            setSearchInformationFromUrl,
        } = this.props;

        // set the pair location-searchCriterias so we can use them later when
        // the user try to navigate back
        setSearchInformationFromUrl(this.props.history.location.pathname, queryString.parse(this.props.history.location.search));

        // track pageview GA action
        onTrackPageViewAction();
        setPageLabel(LUX_LABEL_SEARCH);
        setCustomData('search_version', 'eb-spa');

        // set this hook here so we know when the user hits back on the browser
        // and then we can update the state with that interaction and "simulate"
        // we just hit that url
        // if (this.props.history.action === 'POP') {
        //     this.props.updateSearchInformationFromUrl(this.props.location.pathname, console.log(queryString.parse(this.props.location.search)) || queryString.parse(this.props.location.search.replace('?', '')));
        // }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.location.pathname + prevProps.location.search !== this.props.location.pathname + this.props.location.search) {
            this.props.updateSearchInformationFromUrl(this.props.location.pathname, console.log(queryString.parse(this.props.location.search)) || queryString.parse(this.props.location.search.replace('?', '')));
        }
    }

    _handleGoogleMapsLoaded = () => {
        this.setState({shouldLoadGoogleMap: true});
    }

    _handleOnSaveEvent = (eventId, shouldSave) => {
        const {
            onSaveEvent,
            // location: {
            //     pathname,
            //     query,
            // },
        } = this.props;

        return onSaveEvent(eventId, shouldSave, /*{pathname, query},*/ true);
    }

    _handleTrackEventClickInternal = (data, ticketsBy) => {
        const {
            domain,
            trackEventClickInternal,
        } = this.props;

        const janusCheckpoint = includes(NON_MANUAL_SOURCES, ticketsBy) ? DESTINATION_SEARCH_EVENT_CLICKED_CHECKPOINT : DESTINATION_MANUAL_SEARCH_EVENT_CLICKED_CHECKPOINT;

        logCheckpointOnPageChange(janusCheckpoint, domain);

        trackEventClickInternal(data);
    }

    render() {
        const {
            handleApplyFilter,
            handleRemoveFilter,
            handleLocationSelect,
        } = this.props;

        const oldSearch = (
            <div className="search-base-screen__old">
                <Layout maxWidth="large">
                    <ConnectedSearchHeader
                        onGoogleMapsLoaded={this._handleGoogleMapsLoaded}
                        history={this.props.history}
                    />
                    <ConnectedSearchMainContent
                        onSaveEvent={this._handleOnSaveEvent}
                        onTrackEventClickInternal={this._handleTrackEventClickInternal}
                        shouldLoadGoogleMap={this.state.shouldLoadGoogleMap}
                        history={this.props.history}
                    />
                    <ConnectedSearchFooterLegacy history={this.props.history} />
                </Layout>
            </div>
        );

        const newSearch = (
            <main className="search-base-screen__root">
                <aside className="search-base-screen__filter-panel">
                    <FilterPanel
                        handleApplyFilter={handleApplyFilter}
                        handleRemoveFilter={handleRemoveFilter}
                    />
                </aside>
                <section className="search-base-screen__search-panel">
                    <ConnectedResultsPanel
                        onSaveEvent={this._handleOnSaveEvent}
                        onTrackEventClickInternal={this._handleTrackEventClickInternal}
                        onGoogleMapsLoaded={this._handleGoogleMapsLoaded}
                        history={this.props.history}
                    />
                    <ConnectedSearchFooter history={this.props.history} />
                </section>

                <section className="search-base-screen__map-panel">
                    {this.state.shouldLoadGoogleMap &&
                    <ConnectedMapPanel
                        onSaveEvent={this._handleOnSaveEvent}
                        onTrackEventClickInternal={this._handleTrackEventClickInternal}
                        shouldLoadGoogleMap={this.state.shouldLoadGoogleMap}
                        handleLocationSelect={handleLocationSelect}
                        history={this.props.history}
                    />
                    }
                </section>
            </main>
        );

        return this.props.location.hash === '#new' ? newSearch : oldSearch;
    }
}

export default withRouter(withEventSaveNotification(SearchBaseScreen));

